import { useSnackbar } from '@/features/snackbar';
import { useFlag } from '@/features/unleash';
import { useTranslation } from '@/hooks/useTranslation';
import { useEffect } from 'react';

export function I18nBetaNotification() {
  const flags = useFlag({ name: 'i18n-beta-notification' });
  const { enabled } = flags;
  const { addSnackbar, removeSnackbar } = useSnackbar();
  const t = useTranslation();
  useEffect(() => {
    if (enabled) {
      addSnackbar({
        id: 'toast-i18n-beta-notification',
        message: t('notification.translationBeta'),
        type: 'warning',
        actionLabel: t('notification.translationBeta.secondaryAction'),
      });
    } else {
      removeSnackbar({ id: 'toast-i18n-beta-notification' });
    }
  }, [enabled]);
  return <></>;
}
